
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/forms/register-interest",
      function () {
        return require("private-next-pages/egypt/forms/register-interest.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/forms/register-interest"])
      });
    }
  